"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const zoomin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-zoomin` : '') + (description ? ` desc-zoomin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-zoomin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-zoomin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2031)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.81437 6.01553e-08C15.2331 0.000597922 19.6257 4.39319 19.6263 9.81192C19.6266 12.2055 18.7573 14.457 17.2629 16.2005L23.7817 22.7197C24.0745 23.0126 24.0745 23.4875 23.7816 23.7804C23.5153 24.0466 23.0986 24.0708 22.805 23.8529L22.7209 23.7803L16.2022 17.2618C15.4287 17.9255 14.544 18.4749 13.5691 18.8788C9.90209 20.398 5.68109 19.5585 2.87445 16.7518C0.0678103 13.9452 -0.77168 9.72419 0.747464 6.05723C2.26661 2.39026 5.84518 -0.000437871 9.81437 6.01553e-08ZM9.8142 1.5C6.45174 1.49963 3.42018 3.52489 2.13325 6.63133C0.846322 9.73777 1.55749 13.3136 3.93511 15.6912C6.31273 18.0688 9.88852 18.78 12.995 17.493C14.0229 17.0672 14.9324 16.4503 15.6894 15.6936C17.2227 14.1572 18.1265 12.0585 18.1263 9.81208C18.1258 5.22166 14.4046 1.50051 9.8142 1.5ZM9.75129 4.5C10.131 4.5 10.4448 4.78215 10.4944 5.14823L10.5013 5.25L10.501 8.999L14.2513 9C14.6655 9 15.0013 9.33579 15.0013 9.75C15.0013 10.1297 14.7191 10.4435 14.3531 10.4932L14.2513 10.5L10.501 10.499L10.5013 14.25C10.5013 14.6642 10.1655 15 9.75129 15C9.37159 15 9.0578 14.7178 9.00813 14.3518L9.00129 14.25L9.001 10.499L5.25129 10.5C4.83707 10.5 4.50129 10.1642 4.50129 9.75C4.50129 9.3703 4.78344 9.05651 5.14952 9.00685L5.25129 9L9.001 8.999L9.00129 5.25C9.00129 4.83579 9.33707 4.5 9.75129 4.5Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2031"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = zoomin;